var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 10450",
    d: "M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389974 7.20038 -0.17433 9.00998 0.172936 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89471 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948211 11.3869 0 9 0ZM11.8315 11.8298C11.6569 12.0042 11.4203 12.1021 11.1736 12.1021C10.9269 12.1021 10.6903 12.0042 10.5157 11.8298L8.3804 9.65707C8.20574 9.48265 8.10749 9.24601 8.10725 8.99916V5.27575C8.10725 5.02881 8.20534 4.79199 8.37995 4.61738C8.55456 4.44278 8.79138 4.34468 9.03831 4.34468C9.28524 4.34468 9.52206 4.44278 9.69667 4.61738C9.87128 4.79199 9.96937 5.02881 9.96937 5.27575V8.61525L11.8673 10.514C12.0368 10.6935 12.128 10.9329 12.121 11.1797C12.1139 11.4264 12.0092 11.6603 11.8298 11.8298H11.8315Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlack);
export default __webpack_public_path__ + "static/media/clock-black.ec91d2a71ca9a61ba48a7e512e42122a.svg";
export { ForwardRef as ReactComponent };